import { Navigate, useParams } from "react-router-dom";

const EmailRequestRedirectPage = () => {
  const params = useParams();

  return <Navigate to={`/req?token=${params.requestToken}`} replace={true} />;
};

export default EmailRequestRedirectPage;
